import { graphql } from "gql.tada";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";
// import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { LinkFragment } from "./fragments/LinkFragment";
import { TagFragment } from "./fragments/TagFragment";
import { AccessibleMediaFragment } from "@queries/fragments/AccessibleMediaFragment";

export const GetBlogPageBySlug = graphql(
  `
    query GetBlogPageBySlug(
      $slug: String,
      $locale: String,
      $preview: Boolean
    ) {
      post: blogPostPageCollection(
        where: { slug: $slug }
        locale: $locale,
        preview: $preview
        limit: 1
      ) {
        items {
          sys { id, firstPublishedAt }
          publicationDate
          updatedDate
          slug
          showPageInLocales
          postTitle
          postSummary
          keyTakeaways
          postTldr
          heroImage {
            ...AccessibleMediaFragment
          }
          author {
            sectionTitle
            name
            role
            company
            biography
            linkedInProfileUrl
            profilePhoto {
              contentType
              title
              description
              url
            }
          }
          metadata {
            ...MetadataFragment
          }
          canonicalUrl
          socialShareImage {
            ...AccessibleMediaFragment
          }
          tagsCollection(limit: 20) {
            items {
              ...TagFragment
            }
          }
          bodyCollection(limit: 24) {
            items {
              __typename
              ... on AccessibleMedia {
                ...AccessibleMediaFragment
              }
              ... on SideBySideMedia {
                sys { id }
                title
                mediaCollection {
                  items {
                    ...AccessibleMediaFragment
                  }
                }
              }
              ... on CaseStudyInsightsBlockGroup {
                sys { id }
                blocksCollection(limit: 4) {
                  items {
                    ...RichEntryFragment
                  }
                }
              }
              ... on DescriptionFillSection {
                sys { id }
                title
                descriptionRichText {
                  json
                }
              }
              ... on QuotationCarouselItem {
                sys { id }
                quotation
                attributionName
                attributionPosition
                attributionCompany
              }
              ... on RichEntry {
                sys { id }
                ...RichEntryFragment
              }
            }
          }
          ctaFooter {
            sys { id }
            variant
            isVertical
            title
            titleRichText { json }
            cta { ...LinkFragment }
            backgroundImage { url title }
          }
        }
      }

      feed: blogPostPageCollection(
        locale: $locale,
        preview: $preview
      ) {
        items {
          sys { id, firstPublishedAt }
          publicationDate
          updatedDate
          slug
          postTitle
          postSummary
          postTldr
          heroImage {
            ...AccessibleMediaFragment
          }
          tagsCollection(limit: 20) {
            items {
              ...TagFragment
            }
          }
        }
      }
    }
  `,
  [
    AccessibleMediaFragment,
    LinkFragment,
    MetadataFragment,
    RichEntryFragment,
    TagFragment,
  ]
);
